import { Box, Button, Card, Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import UrbanType from './UrbanType/UrbanType';
import SubscriptionSlab from './Slab/SubscriptionSlab';
import { useDispatch } from 'react-redux';

const Subscription = () => {
  const menuDispatch = useDispatch();
  useEffect(() => {
      menuDispatch({
          type: 'menuSelect',
          payload: 'subscription'
      });
  }, []);
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState('0');
  
  // Handle tab change and update URL
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      {/* ===========page title================= */}
      <PageHeaderLayout headerTitle={'Manage Subscription'}>
        <Button variant='contained' onClick={() => navigate(-1)} sx={{ height: "30px", marginTop: "10px" }} startIcon={<ArrowBack />}>
          Back
        </Button>
      </PageHeaderLayout>
      <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            sx={{ p: 0, minHeight: '40px' }}
            variant="scrollable"
            scrollButtons="auto"
          >

            <Tab value="0" label="Subscription Plan" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
            <Tab value="1" label="Slabs" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
          </Tabs>
        </Box>
      </Card>
      {tabValue === '0' && <UrbanType />}
      {tabValue === '1' && <SubscriptionSlab />}
    </Box>
  );
}

export default Subscription;

